import React from 'react';
// import queryParser from 'query-string';
import common from '../../../common/common';
import intl from 'react-intl-universal';
import InfiniteScroll from 'react-infinite-scroll-component';
import KnowledgeDialog from '../knowledgedialog/index';
import service from '../service';

import styles from './chat.module.scss';
import { PhotoSlider } from 'react-photo-view';
import 'react-photo-view/dist/index.css';

const themeImg = {
  'no-chat': {
    'gen': require('../../../assets/theme-gen/img/star/noChat.png'),
    'mke': require('../../../assets/theme-mke/img/star/noChat.png')
  }
};

const searchParam = common.getSearchParam();
const seconds2HoursAndMinute = (value) => {
  const time = new Date(value * 1000);
  let hours = time.getHours();
  let minutes = time.getMinutes();
  let seconds = time.getSeconds();
  if (hours < 10) hours = '0' + hours;
  if (minutes < 10) minutes = '0' + minutes;
  if (seconds < 10) seconds = '0' + seconds;
  return hours + ':' + minutes;
}

class ChatDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chatList: [],
      isLoading: false,
      isPreview: false,
      imageUrl: '',
      total: -1,
      page: 0,
      size: 50,
    };
  }
  static defaultProps = {};
  handleClose = () => {
    this.setState({ isPreview: false });
  }
  previewImg = url => {
    this.setState({
      isPreview: true,
      imageUrl: url
    });
  }
  getChat = async () => {
    if (this.state.isLoading) return;
    const { cid: classroomId } = searchParam;
    let { size, page, chatList } = this.state;
    page = ++page;
    this.setState({ isLoading: true });
    const { total, chatList: newChatList } = await service.getChatRecordList({ classroomId, size, page, includePrivateChat: true });
    this.setState({
      page,
      isLoading: false,
      total,
      chatList: [
        ...chatList,
        ...newChatList
      ]
    });
  }
  componentDidMount() {
    this.getChat();
  }
  render() {
    const { show, handleCancel, theme } = this.props;
    const { isPreview, imageUrl, chatList, total } = this.state;

    return (
      <div className={`${show ? styles.openChat : styles.closeChat} ${styles.chatWrap}`}>
        <KnowledgeDialog show={true} title={`${intl.get('REPLAY_KNOWLEDGE_POINT_CHAT')}`} isNeedTitleIcon={false} handleCancel={handleCancel}
          position={{ top: '0px', bottom: '0px', right: '0px', height: 'auto', padding: '10px 2px 10px 18px' }}>
          {!chatList.length
            ? (
              <div className={styles.noChat}>
                <img src={themeImg['no-chat'][theme]}></img>
                <div className={styles.noText}>{intl.get('REPLAY_KNOWLEDGE_POINT_QUIET')}</div>
              </div>
            )
            : <ul className={`${styles.knoChatList} light-scroll-bar`} id="scrollableDiv">
                <InfiniteScroll
                    dataLength={chatList.length}
                    next={this.getChat}
                    hasMore={chatList.length < total}
                    // loader={<LoadingOutlined className={styles.loaderIcon}/>}
                    scrollableTarget="scrollableDiv"
                    scrollThreshold={0.9}
                >
                {chatList.map((chat, index) => {
                  const roleNameMap = {
                    1: '老师',
                    2: '助教',
                  };
                  const getName = (role, isTo) => {
                    if (![1,2,3].includes(role)) return '';
                    if (role === 3) {
                      return isTo ? `${chat.toNickName}${chat.toRealName ? `(${chat.toRealName})` : ''}` : `${chat.nickName}${chat.realName ? `(${chat.realName})` : ''}`;
                    } else {
                      return roleNameMap[role];
                    }                    
                  }
                  return (
                    <li className={styles.knoChat} key={index}>
                      <div className={styles.chatTime}>{seconds2HoursAndMinute(chat.sentTime)}</div>
                      <div className={`${styles.chatMain} ${(+chat.role === 1 || +chat.role === 2) ? styles.isTeaOrAss : ''} ${+chat.role === 3 ? styles.isStu : ''}`}>
                        {chat.uid == searchParam.uid && <span className={styles.isMe}>{intl.get('REPLAY_KNOWLEDGE_POINT_ME')}</span>}
                        {(+chat.role === 1 || +chat.role === 2) && <span className={`${styles.chatIcon} ${+chat.role === 1 ? styles.chatTeaIcon : ''} ${+chat.role === 2 ? styles.chatAssIcon : ''}`}></span>}
                        {chat.toRole ? (
                          <span className={styles.name}>
                            <span className={styles.name}>{chat.uid == searchParam.uid ? '我' : getName(chat.role, false)}</span>
                            对
                            <span className={styles.name}>{chat.toUid == searchParam.uid ? '我' : getName(chat.toRole, true)}</span>
                            <span className={styles.private}>[私聊]：</span> 
                          </span>
                        )
                          : (<span className={styles.name}>{chat.nickName}{chat.realName ? `（${chat.realName}）：` : '：'}</span>)}
                        <>
                          {chat.content.map((content, index) => {
                            {
                              return content.type === 1
                                ? <span key={index} className={styles.chatContent}>{content.text}</span>
                                : <img key={index} className={styles.chatImg} onClick={this.previewImg.bind(this, content.text)} src={content.text}></img>
                            }
                          })}
                        </>
                      </div>
                    </li>
                  )})}
                </InfiniteScroll>
              </ul>
          }
        </KnowledgeDialog>
        <PhotoSlider images={[{ src: imageUrl }]} visible={isPreview} onClose={this.handleClose} />
      </div>
    )
  }
}

export default ChatDialog;
